export default __webpack_public_path__ + "v3.375/youtube-icon.png";